export default {
    "sectionsBlockHeaderTemplate": "componentsCompany/level/CardSectionsBlockHeader",
    "sectionsBlockFooterTemplate": "componentsCompany/level/CardSectionsBlockFooter",
    "sections": {
        "library": {
            "showName": "Библиотечные цели",
            "fromLibrary": "library",
            "emptyText": "Нет целей",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "weight": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.point": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "scale.point_admin": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "scale.result": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan",
                        "plan_comments"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "plan",
                        "plan_comments",
                        "assessment",
                        "finalizing"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "kpi": {
            "showName": "Ключевые показатели эффективности (KPI)",
            "emptyText": "Нет целей",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "name": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "desc": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "weight": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.unit": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.expectation_above": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.expectation_equal": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.expectation_partial": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.point": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "scale.point_admin": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "scale.result": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan",
                        "plan_comments"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "plan",
                        "plan_comments",
                        "assessment",
                        "finalizing"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "cross": {
            "showName": "Кросс-функциональные цели",
            "emptyText": "Нет целей",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "name": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "desc": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "weight": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.unit": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.expectation_above": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.expectation_equal": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.expectation_partial": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.point": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "scale.point_admin": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "scale.result": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan",
                        "plan_comments"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "plan",
                        "plan_comments",
                        "assessment",
                        "finalizing"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "mbo": {
            "showName": "Стратегические цели (MBO)",
            "emptyText": "Нет целей",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "name": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "desc": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "weight": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.unit": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.expectation_above": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.expectation_equal": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.expectation_partial": {
                    "stages": [
                        "plan",
                        "finalizing"
                    ]
                },
                "scale.point": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "scale.point_admin": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "scale.result": {
                    "stages": [
                        "assessment",
                        "finalizing"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan",
                        "plan_comments"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "plan",
                        "plan_comments",
                        "assessment",
                        "finalizing"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "a": {
            "showName": "А - выше ожиданий",
            "emptyText": "Нет целей",
            "columnsConfig": "abcd_columns",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "scale.expectation_above": {
                    "stages": [
                        "plan"
                    ]
                },
                "scale.result": {
                    "stages": [
                        "assessment"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "plan",
                        "plan_comments",
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "b": {
            "showName": "В - соответствует ожиданиям",
            "emptyText": "Нет целей",
            "columnsConfig": "abcd_columns",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "scale.expectation_above": {
                    "stages": [
                        "plan"
                    ]
                },
                "scale.result": {
                    "stages": [
                        "assessment"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "plan",
                        "plan_comments",
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "c": {
            "showName": "С- частично соответствует ожиданиям",
            "emptyText": "Нет целей",
            "columnsConfig": "abcd_columns",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "scale.expectation_above": {
                    "stages": [
                        "plan"
                    ]
                },
                "scale.result": {
                    "stages": [
                        "assessment"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "plan",
                        "plan_comments",
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "d": {
            "showName": "D - не соответствует ожиданиям",
            "emptyText": "Нет целей",
            "columnsConfig": "abcd_columns",
            "hideOnStagesIfEmpty": [
                "assessment",
                ""
            ],
            "fieldsAvailableForEdit": {
                "scale.expectation_above": {
                    "stages": [
                        "plan"
                    ]
                },
                "scale.result": {
                    "stages": [
                        "assessment"
                    ]
                },
                "comment.plan": {
                    "stages": [
                        "plan"
                    ],
                    "skipElementEditPermissionsCheck": true
                },
                "comment.assessment": {
                    "stages": [
                        "plan",
                        "plan_comments",
                        "assessment"
                    ],
                    "skipElementEditPermissionsCheck": true
                }
            }
        },
        "extra": {
            "showName": "Экстра цели",
            "emptyText": "Нет целей",
            "columnsConfig": "extra_columns",
            "hideOnStagesIfEmpty": [
                "plan",
                "plan_comments",
                "finalizing",
                ""
            ],
            "fieldsAvailableForEdit": {
                "name": {
                    "stages": [
                        "assessment"
                    ]
                },
                "desc": {
                    "stages": [
                        "assessment"
                    ]
                },
                "scale.point": {
                    "stages": [
                        "assessment"
                    ]
                },
                "scale.point_admin": {
                    "stages": [
                        "assessment"
                    ]
                }
            }
        }
    },
    "default_columns": [
        {
            "label": "Цель",
            "minWidth": 200,
            "template": "components/tableColumnTemplates/card/ElementNameTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Единица измерения",
            "width": 90,
            "template": "components/tableColumnTemplates/card/ElementUnitTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Вес",
            "width": 70,
            "template": "components/tableColumnTemplates/card/ElementWeightTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "Выше ожиданий (150%)",
            "if": "templateData.$canAndRulesPass(templateData.card, \"card.is_full_for_current_user\")",
            "minWidth": 200,
            "template": "componentsCompany/level/tableColumnTemplates/card/ElementExpectationAboveTableColumn.vue",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Соответствует ожиданиям (100%)",
            "minWidth": 200,
            "template": "componentsCompany/level/tableColumnTemplates/card/ElementExpectationEqualTableColumn.vue",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Частично соответствует ожиданиям (50%)",
            "if": "templateData.$canAndRulesPass(templateData.card, \"card.is_full_for_current_user\")",
            "minWidth": 200,
            "template": "componentsCompany/level/tableColumnTemplates/card/ElementExpectationPartialTableColumn.vue",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Комментарий к плану",
            "if": "templateData.$canAndRulesPass(templateData.card, \"card.is_full_for_current_user\")",
            "width": 120,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'plan'",
                "last-comment": "scope.row.last_comment_by_stage['plan']",
                "comments-count": "scope.row.comments_count_by_stage['plan']"
            }
        },
        {
            "label": "Оценка",
            "if": "templateData.$canAndRulesPass(templateData.card, \"card.is_full_for_current_user\")",
            "width": 100,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "componentsCompany/level/tableColumnTemplates/card/ElementPointTableColumn.vue",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Оценка Админа",
            "if": "templateData.user.roles.includes(\"admin\") && templateData.$canAndRulesPass(templateData.card, \"card.is_full_for_current_user\")",
            "width": 100,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "componentsCompany/level/tableColumnTemplates/card/ElementPointAdminTableColumn.vue",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Результат",
            "if": "templateData.$canAndRulesPass(templateData.card, \"card.is_full_for_current_user\")",
            "minWidth": 200,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "componentsCompany/level/tableColumnTemplates/card/ElementResultTableColumn.vue",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Комментарий к факту",
            "if": "templateData.card.user_id === templateData.user.id",
            "width": 120,
            "showOnStages": [
                "plan",
                "plan_comments",
                "finalizing"
            ],
            "showOnStagesWhileNoNegotiation": [
                "plan",
                "plan_comments",
                "finalizing",
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'assessment'",
                "last-comment": "scope.row.last_comment_by_stage['assessment']",
                "comments-count": "scope.row.comments_count_by_stage['assessment']"
            }
        },
        {
            "label": "Комментарий к факту",
            "if": "templateData.$canAndRulesPass(templateData.card, \"card.is_full_for_current_user\")",
            "width": 120,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'assessment'",
                "last-comment": "scope.row.last_comment_by_stage['assessment']",
                "comments-count": "scope.row.comments_count_by_stage['assessment']"
            }
        },
        {
            "label": "",
            "if": "templateData.$canAndRulesPass(templateData.user, \"card_element.hide\")",
            "template": "componentsCompany/level/tableColumnTemplates/card/ElementHideTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            },
            "align": "'center'",
            "width": 50
        },
        {
            "label": "",
            "template": "componentsCompany/level/tableColumnTemplates/card/ElementActionsTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            },
            "align": "'center'",
            "width": 70
        }
    ],
    "extra_columns": [
        {
            "label": "Цель",
            "minWidth": 200,
            "template": "components/tableColumnTemplates/card/ElementNameTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Процент выполнения",
            "width": 200,
            "template": "componentsCompany/level/tableColumnTemplates/card/ElementPercentTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged(); }"
            }
        },
        {
            "label": "",
            "template": "components/tableColumnTemplates/card/ElementActionsTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            },
            "align": "'center'",
            "width": 50
        }
    ],
    "abcd_columns": [
        {
            "label": "Описание оценки",
            "minWidth": 200,
            "template": "components/tableColumnTemplates/card/ElementDescTableColumn",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Ключевые показатели эффективности",
            "minWidth": 200,
            "template": "componentsCompany/level/tableColumnTemplates/card/ElementABCDPlanTableColumn.vue",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Комментарий к плану",
            "width": 120,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'plan'",
                "last-comment": "scope.row.last_comment_by_stage['plan']",
                "comments-count": "scope.row.comments_count_by_stage['plan']"
            }
        },
        {
            "label": "Факт",
            "minWidth": 200,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "componentsCompany/level/tableColumnTemplates/card/ElementResultTableColumn.vue",
            "bind": {
                "scope": "scope"
            },
            "on": {
                "elements-changed": "() => { templateData.elementsChanged() }"
            }
        },
        {
            "label": "Комментарий к факту",
            "width": 120,
            "showOnStages": [
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'assessment'",
                "last-comment": "scope.row.last_comment_by_stage['assessment']",
                "comments-count": "scope.row.comments_count_by_stage['assessment']"
            }
        },
        {
            "label": "Комментарий к факту",
            "if": "templateData.card.user_id === templateData.user.id",
            "width": 120,
            "showOnStages": [
                "plan"
            ],
            "showOnStagesWhileNoNegotiation": [
                "plan",
                "assessment"
            ],
            "showOnCompleted": true,
            "template": "components/tableColumnTemplates/card/ElementCommentsTableColumn",
            "bind": {
                "scope": "scope",
                "stage": "'assessment'",
                "last-comment": "scope.row.last_comment_by_stage['assessment']",
                "comments-count": "scope.row.comments_count_by_stage['assessment']"
            }
        }
    ]
}